import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import { Link } from 'react-router-dom';
import { ChurchIcon, BookIcon, UserIcon, CalendarIcon, MapPinIcon, HeartIcon, BuildingIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const EmmanuelChurch = () => {
  const earlyConverts = ['Israel Orebanjo', 'Alexander Bamgbaiye', 'Joshua Yemi', 'Samuel Ogunsanya', 'Samuel Lalu', 'John Fashina', 'Jacob Torimiro', 'James Fanoiki', 'Akinleye', 'Timilehin', 'Ayantuga', 'Anwoju', 'Madam Dorcas Adefowoke the First Iya Egbe of Emmanuel Church Isonyin'];
  const firstBaptized = ['Israel Orebanjo', 'David Owen', 'Daniel Otunba', 'Samuel Coker', 'Isaiah Foworanu', 'Joshua Oduyemi', 'George Isaac', 'Solomon Adelakun', 'Samuel Lalu', 'Emmanuel Ayantuga', 'Emmanuel Okusanya', 'Jacob Torimiro', 'Isaac Sanya', 'Daniel Adeoye', 'John Osunsan', 'Daniel Yemi', 'Joseph Odusanya', 'Emmanuel Nariwo', 'Joel Anwaju', 'Isaiah Igbokoyi', 'Ezekiel Dosumu', 'Jacob Lekuti', 'Joel Ogunkoya', 'David Debowajo', 'Daniel ogundeji', 'Jacon Olugbuyi', 'Jacob Ayangbesan', 'Emmanuel Semowo', 'James Odubanjo', 'Josiah Osidipe', 'James Fanoiki', 'Daniel Osoyomi', 'Samuel Adeniyi', 'Jones Olubajo', 'Jacon Aiyere', 'Jonah Odusanya'];
  const priests = [{
    name: 'Mr. Banjoko',
    years: '1896 – 1897',
    role: 'Teacher'
  }, {
    name: 'Mr. I. B. Ogunmefun',
    years: '1897 – 1907',
    role: 'Catechist'
  }, {
    name: 'Rev. I. B. Ogunmefun',
    years: '1907 – 1922',
    role: ''
  }, {
    name: 'Rev. S. A. Sobande',
    years: '1922 – 1926',
    role: ''
  }, {
    name: 'Rev. D. A. Oduwusi',
    years: '1927 – 1928',
    role: ''
  }, {
    name: 'Rev. D. A. Ogunbanjo',
    years: '1929 – 1933',
    role: ''
  }, {
    name: 'Vacant',
    years: '1933 – 1936',
    role: ''
  }, {
    name: 'Rev. D. A. Olaitan',
    years: '1937 – 1947',
    role: ''
  }, {
    name: 'Rev. I. F. Ekundayo',
    years: '1948 – 1949',
    role: ''
  }, {
    name: 'Rev. S. A. Oduwale',
    years: '1949 – 1953',
    role: ''
  }, {
    name: 'Rev. D. A. Olugbile',
    years: '1954 – 1957',
    role: ''
  }, {
    name: 'Rev. I. I. Ipinmoye',
    years: '1958 – 1963',
    role: ''
  }, {
    name: 'Rev. J. O. Olojo',
    years: '1965 – 1976',
    role: ''
  }, {
    name: 'Ven. R. A. Osisanwo',
    years: '1977 – 1980',
    role: ''
  }, {
    name: 'Ven. E. O. Dosumu',
    years: '1980 – 1991',
    role: ''
  }, {
    name: 'Ven. E. O. J. SOkale',
    years: '1991 – 1992',
    role: ''
  }, {
    name: 'Ven. J. O. Fowowe',
    years: 'Jan 1993 – Aug. 1993',
    role: ''
  }, {
    name: 'Ven. S. O. Oluwatosin',
    years: 'Aug. 1993 – 1999',
    role: ''
  }, {
    name: 'Ven. J. O. Bamgbose',
    years: '1999 – 2005',
    role: ''
  }, {
    name: 'Ve. J. R. Olowomeye',
    years: '2005 – 2013',
    role: ''
  }, {
    name: 'Ven. Dr. E. B. Dairo',
    years: '2013 – 2020',
    role: ''
  }];
  const timelineEvents = [{
    year: '1894',
    event: 'Israel Orebanjo meets Joseph Odumosu at the Church Missionary Society Bookshop in Lagos, leading to the first visit of Joseph Odumosu, Olusoga, and Kogbe to Isonyin.'
  }, {
    year: '1894-1897',
    event: "Foundation period of the infant church at Isonyin, with services initially held in Israel Orebanjo's house and later in an improvised booth."
  }, {
    year: '1898',
    event: 'Plans begin for a new church building as the wooden structure with thatched roof could no longer accommodate the growing congregation.'
  }, {
    year: '1901',
    event: 'Completion and dedication of the new church building by Rev. R. A. Coker, the Superintendent of Ijebu-Ode Church District.'
  }];
  return <div className="min-h-screen bg-white" data-id="element-3199">
      <PageHeader title="Emmanuel Church Isonyin" description="The history and development of Christianity in Isonyin through the Emmanuel Church." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/j7qggriEhJn36QjHDspNE7/WhatsApp_Image_2025-11-07_at_19.20.04.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'About',
      path: '/about'
    }, {
      label: 'Emmanuel Church',
      path: '/emmanuel-church'
    }]} data-id="element-3200" />
      <div className="container mx-auto px-4 py-12" data-id="element-3201">
        {/* Church Photo Gallery Section */}
        <section className="mb-16" data-id="element-3202">
          <div className="text-center mb-10" data-id="element-3203">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3204">
              Emmanuel Church Today
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3205"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-3206">
              A beautiful testament to faith, heritage, and community dedication
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-3207">
            <div className="relative overflow-hidden rounded-lg shadow-xl group" data-id="element-3208">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9RHDzyngTbhxhLw7T2f6LL/WhatsApp_Image_2025-11-07_at_19.20.04_%281%29.jpg" alt="Emmanuel Church Isonyin - Side View" className="w-full h-96 object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-3209" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-900/90 to-transparent p-6" data-id="element-3210">
                <p className="text-white font-bold text-lg" data-id="element-3211">
                  The Historic Church Building
                </p>
                <p className="text-white/90 text-sm" data-id="element-3212">
                  Featuring distinctive architecture and arched windows
                </p>
              </div>
            </div>
            <div className="relative overflow-hidden rounded-lg shadow-xl group" data-id="element-3213">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j7qggriEhJn36QjHDspNE7/WhatsApp_Image_2025-11-07_at_19.20.04.jpg" alt="Emmanuel Church Isonyin - Tower View" className="w-full h-96 object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-3214" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-900/90 to-transparent p-6" data-id="element-3215">
                <p className="text-white font-bold text-lg" data-id="element-3216">
                  The Majestic Church Tower
                </p>
                <p className="text-white/90 text-sm" data-id="element-3217">
                  A landmark visible throughout Isonyin
                </p>
              </div>
            </div>
          </div>
          <div className="relative overflow-hidden rounded-lg shadow-xl" data-id="element-3218">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6z3HZvzDVgyVebD816tqR7/WhatsApp_Image_2025-11-07_at_19.20.03.jpg" alt="Emmanuel Church Isonyin - Front View" className="w-full h-[500px] object-cover" data-id="element-3219" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-900/95 to-transparent p-8" data-id="element-3220">
              <p className="text-white font-bold text-2xl mb-2" data-id="element-3221">
                Emmanuel Church Isonyin
              </p>
              <p className="text-white/90" data-id="element-3222">
                From humble beginnings in 1894 to this magnificent structure - a
                testament to faith, perseverance, and community spirit
              </p>
            </div>
          </div>
        </section>
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-3223">
          <div className="text-center mb-10" data-id="element-3224">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3225">
              The Beginning of an Organized Church in Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3226"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-3227">
            <div data-id="element-3228">
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-3229">
                The Emmanuel Church was formed by a group of early converts who
                were committed to establishing Christianity in Isonyin. Israel
                Orebanjo played a pivotal role in ensuring that the new church
                was nurtured and built upon a sound foundation. As a leader and
                founder, services were initially held in his house before a
                booth was improvised under his direction.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-3230">
                A notable turning point in the development of Christianity at
                Isonyin came in 1894 when Israel Orebanjo went to purchase
                copies of the ABD book at the Church Missionary Society Bookshop
                in Lagos. There, he met Joseph Odumosu, who was curious about
                the quantity of books Orebanjo was purchasing. This fortuitous
                meeting led to Odumosu, accompanied by Olusoga and Kogbe alias
                "Welli we," visiting Isonyin two weeks later, greatly
                encouraging the local Christians.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-3231">
                For nearly four years, between 1894 and 1897, the infant church
                at Isonyin established a secure foundation. It had a teacher, a
                meeting place for communal services, and a strong core of
                talented leaders. By 1898, the wooden structure with thatched
                roof could no longer accommodate the growing congregation,
                prompting plans for a new church building.
              </p>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg shadow-md" data-id="element-3232">
              <h3 className="text-xl font-bold text-blue-900 mb-4 flex items-center" data-id="element-3233">
                <ChurchIcon className="mr-2 h-6 w-6 text-blue-700" data-id="element-3234" />
                Historical Timeline
              </h3>
              <div className="space-y-6" data-id="element-3235">
                {timelineEvents.map((item, index) => <div key={index} className="flex" data-id="element-3236">
                    <div className="flex-shrink-0 w-20 font-bold text-blue-900" data-id="element-3237">
                      {item.year}
                    </div>
                    <div className="flex-grow pl-4 border-l-2 border-blue-200" data-id="element-3238">
                      <p className="text-gray-700" data-id="element-3239">{item.event}</p>
                    </div>
                  </div>)}
                <div className="flex" data-id="element-3240">
                  <div className="flex-shrink-0 w-20 font-bold text-blue-900" data-id="element-3241">
                    Present
                  </div>
                  <div className="flex-grow pl-4 border-l-2 border-blue-200" data-id="element-3242">
                    <p className="text-gray-700" data-id="element-3243">
                      The church later became the seat of Ijebu North East
                      Archdeaconry and is presently Isonyin Archdeaconry.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Church Building Section */}
        <section className="mb-16" data-id="element-3244">
          <div className="text-center mb-10" data-id="element-3245">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3246">
              Construction of the Church Building
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3247"></div>
          </div>
          <div className="bg-blue-900 text-white p-8 rounded-lg" data-id="element-3248">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-3249">
              <div data-id="element-3250">
                <h3 className="text-2xl font-bold mb-4" data-id="element-3251">
                  From Humble Beginnings
                </h3>
                <p className="mb-4 leading-relaxed" data-id="element-3252">
                  The journey to build a permanent church structure began in
                  early 1898. The growing Christian community in Isonyin faced
                  various challenges as they worked to establish a proper place
                  of worship.
                </p>
                <p className="mb-4 leading-relaxed" data-id="element-3253">
                  Despite these challenges, the community persevered, commencing
                  the building process towards the end of 1898. Through their
                  collective effort and dedication, the church building was
                  completed in 1901.
                </p>
                <p className="leading-relaxed" data-id="element-3254">
                  The new Emmanuel Church was dedicated by Rev. R. A. Coker, the
                  Superintendent of Ijebu-Ode Church District, marking a
                  significant milestone in the growth of Christianity in
                  Isonyin.
                </p>
              </div>
              <div className="bg-blue-800 p-6 rounded-lg" data-id="element-3255">
                <div className="flex items-center mb-4" data-id="element-3256">
                  <MapPinIcon className="h-6 w-6 text-yellow-400 mr-3" data-id="element-3257" />
                  <h4 className="text-xl font-bold" data-id="element-3258">Historical Significance</h4>
                </div>
                <p className="mb-4" data-id="element-3259">
                  The establishment of Emmanuel Church represented more than
                  just a physical building; it symbolized the firm establishment
                  of Christianity in Isonyin and laid the foundation for future
                  growth.
                </p>
                <p data-id="element-3260">
                  From its humble beginnings in Israel Orebanjo's home to
                  becoming the seat of an Archdeaconry, Emmanuel Church has
                  played a pivotal role in the spiritual and social development
                  of the Isonyin community for over a century.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Multipurpose Hall Project & Contributors Section */}
        <section className="mb-16" data-id="element-3261">
          <div className="text-center mb-10" data-id="element-3262">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3263">
              The Multipurpose Hall Project
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3264"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-3265">
              A testament to the generosity and commitment of the Isonyin
              community
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8" data-id="element-3266">
            <div className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-lg shadow-lg border border-blue-100" data-id="element-3267">
              <div className="flex items-center mb-6" data-id="element-3268">
                <div className="bg-yellow-500 p-3 rounded-full mr-4" data-id="element-3269">
                  <BuildingIcon className="h-8 w-8 text-blue-900" data-id="element-3270" />
                </div>
                <h3 className="text-2xl font-bold text-blue-900" data-id="element-3271">
                  Community Development
                </h3>
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-3272">
                The Emmanuel Church Multipurpose Hall Project represents a
                significant investment in the future of the Isonyin community.
                This facility serves not only as a place of worship but also as
                a center for community gatherings, educational programs, and
                social events.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-3273">
                The successful completion of this project was made possible
                through the generous contributions of numerous individuals,
                families, and organizations who recognized the importance of
                having a modern facility to serve the growing needs of the
                congregation and community.
              </p>
            </div>
            <div className="relative overflow-hidden rounded-lg shadow-xl" data-id="element-3274">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j6HhKRSewjtwZJFHKZGw82/WhatsApp_Image_2025-11-07_at_19.20.05.jpg" alt="Contributors Plaque - Emmanuel Church Multipurpose Hall" className="w-full h-full object-cover" data-id="element-3275" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-900/95 to-transparent p-6" data-id="element-3276">
                <p className="text-white font-bold text-lg flex items-center" data-id="element-3277">
                  <HeartIcon className="h-5 w-5 mr-2" data-id="element-3278" />
                  Major Financial Contributors
                </p>
                <p className="text-white/90 text-sm" data-id="element-3279">
                  Honoring those who made the multipurpose hall possible
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg border-2 border-yellow-500" data-id="element-3280">
            <div className="text-center mb-6" data-id="element-3281">
              <h3 className="text-2xl font-bold text-blue-900 mb-2" data-id="element-3282">
                Gratitude and Recognition
              </h3>
              <p className="text-gray-600" data-id="element-3283">
                We extend our heartfelt appreciation to all contributors,
                including:
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3284">
              <div className="bg-blue-50 p-6 rounded-lg" data-id="element-3285">
                <div className="flex items-center mb-3" data-id="element-3286">
                  <HeartIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-3287" />
                  <h4 className="font-bold text-blue-900" data-id="element-3288">Individual Donors</h4>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-3289">
                  Numerous individuals who contributed generously to make this
                  project a reality
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg" data-id="element-3290">
                <div className="flex items-center mb-3" data-id="element-3291">
                  <HeartIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-3292" />
                  <h4 className="font-bold text-blue-900" data-id="element-3293">
                    Family Contributions
                  </h4>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-3294">
                  Families who united in their support for the church's
                  development
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg" data-id="element-3295">
                <div className="flex items-center mb-3" data-id="element-3296">
                  <HeartIcon className="h-5 w-5 text-blue-700 mr-2" data-id="element-3297" />
                  <h4 className="font-bold text-blue-900" data-id="element-3298">
                    Organizations & Societies
                  </h4>
                </div>
                <p className="text-gray-700 text-sm" data-id="element-3299">
                  Various organizations and societies that provided crucial
                  financial support
                </p>
              </div>
            </div>
            <div className="mt-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200" data-id="element-3300">
              <p className="text-gray-700 text-center italic" data-id="element-3301">
                "The completion of the multipurpose hall stands as a monument to
                the faith, generosity, and unity of the Isonyin community. May
                this facility continue to serve generations to come."
              </p>
            </div>
          </div>
        </section>
        {/* Early Converts Section */}
        <section className="mb-16" data-id="element-3302">
          <div className="text-center mb-10" data-id="element-3303">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3304">
              The Founding Members
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3305"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-3306">
              The early converts who formed Emmanuel Church and laid the
              foundation for Christianity in Isonyin.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3307">
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200" data-id="element-3308">
              <h3 className="text-xl font-bold text-blue-900 mb-4 flex items-center" data-id="element-3309">
                <UserIcon className="mr-2 h-6 w-6 text-blue-700" data-id="element-3310" />
                Early Converts
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-3311">
                {earlyConverts.map((name, index) => <div key={index} className="flex items-center py-2 border-b border-gray-100" data-id="element-3312">
                    <span className="w-6 h-6 flex items-center justify-center bg-blue-100 text-blue-700 rounded-full text-xs font-bold mr-2" data-id="element-3313">
                      {index + 1}
                    </span>
                    <span className="text-gray-700" data-id="element-3314">{name}</span>
                  </div>)}
              </div>
              <p className="mt-4 text-gray-600 italic" data-id="element-3315">
                Israel Orebanjo ensured that the new church was nurtured and
                built upon a sound foundation. As a leader and founder, services
                were held in his house at first.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200" data-id="element-3316">
              <h3 className="text-xl font-bold text-blue-900 mb-4 flex items-center" data-id="element-3317">
                <BookIcon className="mr-2 h-6 w-6 text-blue-700" data-id="element-3318" />
                The Joseph Odumosu Connection
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-3319">
                The notable and worthy part played in the development of
                Christianity at Isonyin by the late Joseph Odumosu of Ijebu-Ode
                cannot be forgotten. His first contact with Isonyin Christians
                was incidental, occurring at the Church Missionary Society
                Bookshop in Lagos in 1894.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-3320">
                Odumosu observed Israel Orebanjo purchasing a large quantity of
                ABD books and was evidently amazed. His curiosity led him to
                inquire about Orebanjo, where he came from, and for whom the
                books were meant.
              </p>
              <p className="text-gray-700" data-id="element-3321">
                Two weeks after their fortuitous meeting in Lagos, Odumosu
                accompanied by Olusoga and Kogbe alias "Welli we" came to
                Isonyin. The Christians were greatly and obviously cheered by
                this visit. Thereafter, Odumosu, Kogbe, Odunewu, and Adebogun
                came regularly from Ijebu-Ode to Isonyin to preach at Sunday
                Services and to encourage the Christians.
              </p>
            </div>
          </div>
        </section>
        {/* First Baptized Christians Section */}
        <section className="mb-16" data-id="element-3322">
          <div className="text-center mb-10" data-id="element-3323">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3324">
              First Baptized Christians from Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3325"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-3326">
              The first members of the Isonyin community who received baptism,
              marking the official establishment of Christianity in the area.
            </p>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg border border-gray-200" data-id="element-3327">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-3328">
              {firstBaptized.map((name, index) => <div key={index} className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 flex items-center" data-id="element-3329">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3330">
                    <span className="text-blue-700 font-bold text-sm" data-id="element-3331">
                      {index + 1}
                    </span>
                  </div>
                  <span className="text-gray-700" data-id="element-3332">{name}</span>
                </div>)}
            </div>
            <div className="mt-6 text-center" data-id="element-3333">
              <p className="text-gray-600 italic" data-id="element-3334">
                Additionally, thirteen members from Odosenlu were also baptized,
                though their names were not recorded.
              </p>
            </div>
          </div>
        </section>
        {/* Priests Section */}
        <section className="mb-16" data-id="element-3335">
          <div className="text-center mb-10" data-id="element-3336">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3337">
              Priests Who Have Served at Emmanuel Church
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3338"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-3339">
              The spiritual leaders who have guided Emmanuel Church Isonyin
              through its history.
            </p>
          </div>
          <div className="overflow-x-auto" data-id="element-3340">
            <table className="min-w-full bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-3341">
              <thead className="bg-blue-900 text-white" data-id="element-3342">
                <tr data-id="element-3343">
                  <th className="py-3 px-4 text-left" data-id="element-3344">No.</th>
                  <th className="py-3 px-4 text-left" data-id="element-3345">Name</th>
                  <th className="py-3 px-4 text-left" data-id="element-3346">Period</th>
                  <th className="py-3 px-4 text-left" data-id="element-3347">Role</th>
                </tr>
              </thead>
              <tbody data-id="element-3348">
                {priests.map((priest, index) => <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-3349">
                    <td className="py-3 px-4 border-b border-gray-200" data-id="element-3350">
                      {index + 1}
                    </td>
                    <td className="py-3 px-4 border-b border-gray-200 font-medium" data-id="element-3351">
                      {priest.name}
                    </td>
                    <td className="py-3 px-4 border-b border-gray-200" data-id="element-3352">
                      <div className="flex items-center" data-id="element-3353">
                        <CalendarIcon className="h-4 w-4 mr-2 text-blue-700" data-id="element-3354" />
                        {priest.years}
                      </div>
                    </td>
                    <td className="py-3 px-4 border-b border-gray-200" data-id="element-3355">
                      {priest.role}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </section>
        {/* Current Status Section */}
        <section className="mb-16" data-id="element-3356">
          <div className="text-center mb-10" data-id="element-3357">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3358">
              Emmanuel Church Today
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3359"></div>
          </div>
          <div className="bg-blue-50 p-8 rounded-lg" data-id="element-3360">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-3361">
              <div data-id="element-3362">
                <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-3363">
                  From Church to Archdeaconry
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-3364">
                  From its humble beginnings in Israel Orebanjo's home, Emmanuel
                  Church has grown significantly over the decades. What started
                  as a small gathering of believers has evolved into a major
                  religious institution in the region.
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-3365">
                  The church later became the seat of Ijebu North East
                  Archdeaconry and is presently Isonyin Archdeaconry, serving as
                  a spiritual center for the wider community and continuing its
                  mission of spreading Christianity throughout the region.
                </p>
                <div className="mt-6" data-id="element-3366">
                  <Button href="/contact" variant="secondary" data-id="element-3367">
                    Contact for More Information
                  </Button>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200" data-id="element-3368">
                <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-3369">
                  Historical Significance
                </h3>
                <ul className="space-y-3" data-id="element-3370">
                  <li className="flex items-start" data-id="element-3371">
                    <div className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" data-id="element-3372">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3373">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3374" />
                      </svg>
                    </div>
                    <div className="text-gray-700" data-id="element-3375">
                      <span className="font-bold" data-id="element-3376">
                        Pioneer of Christianity:
                      </span>{' '}
                      One of the earliest Christian churches in the Ijebu region
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-3377">
                    <div className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" data-id="element-3378">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3379">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3380" />
                      </svg>
                    </div>
                    <div className="text-gray-700" data-id="element-3381">
                      <span className="font-bold" data-id="element-3382">Educational Role:</span>{' '}
                      Instrumental in promoting literacy and education in
                      Isonyin
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-3383">
                    <div className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" data-id="element-3384">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3385">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3386" />
                      </svg>
                    </div>
                    <div className="text-gray-700" data-id="element-3387">
                      <span className="font-bold" data-id="element-3388">Community Development:</span>{' '}
                      Played a key role in the social and cultural development
                      of Isonyin
                    </div>
                  </li>
                  <li className="flex items-start" data-id="element-3389">
                    <div className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" data-id="element-3390">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" data-id="element-3391">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-3392" />
                      </svg>
                    </div>
                    <div className="text-gray-700" data-id="element-3393">
                      <span className="font-bold" data-id="element-3394">Architectural Heritage:</span>{' '}
                      The church building represents an important part of local
                      architectural history
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* Connection to IGS Section */}
        <section data-id="element-3395">
          <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-lg overflow-hidden" data-id="element-3396">
            <div className="container mx-auto px-4 py-12" data-id="element-3397">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-3398">
                <div data-id="element-3399">
                  <h2 className="text-3xl font-bold mb-4" data-id="element-3400">
                    Connection to Isonyin Grammar School
                  </h2>
                  <p className="mb-6 leading-relaxed" data-id="element-3401">
                    The establishment of Emmanuel Church played a significant
                    role in the educational development of Isonyin, creating a
                    foundation for learning and literacy that would later
                    contribute to the founding of Isonyin Grammar School.
                  </p>
                  <p className="mb-6 leading-relaxed" data-id="element-3402">
                    Many of the early advocates for formal education in the
                    community were members of Emmanuel Church, demonstrating the
                    historical connection between faith and education in
                    Isonyin's development.
                  </p>
                  <div data-id="element-3403">
                    <Button href="/about" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-3404">
                      Learn More About IGS History
                    </Button>
                  </div>
                </div>
                <div className="relative" data-id="element-3405">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg" alt="Students in classroom at IGS" className="rounded-lg shadow-lg" data-id="element-3406" />
                  <div className="absolute -bottom-4 -right-4 bg-yellow-500 text-blue-900 font-bold py-2 px-4 rounded-lg transform rotate-3 shadow-lg" data-id="element-3407">
                    Faith & Education
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default EmmanuelChurch;